/**
 * One-time Message Requests explainer (#4671), backing
 * pm/partials/requests-explainer.twig.
 *
 * Every way out saves a choice. "Got it", the close button, the backdrop and
 * Escape save the split. "Keep one inbox" saves the combined inbox, reloads so
 * the requests join the list, and then offers an undo.
 */
(function () {
  'use strict';

  // Carries the undo offer across the reload that "Keep one inbox" needs.
  var ONE_INBOX_TOAST_KEY = 'pm:one-inbox-toast';

  function saveChoice(enabled) {
    var userId = typeof window.pmCurrentUserId === 'function' ? window.pmCurrentUserId() : null;
    if (!userId) {
      return Promise.reject(new Error('No current user'));
    }

    return window.apiRequestOk('/settings/' + userId, {
      method: 'PUT',
      body: new URLSearchParams({ message_requests: enabled ? 'true' : 'false' })
    });
  }

  function remember(flag) {
    try {
      if (flag) {
        window.sessionStorage.setItem(ONE_INBOX_TOAST_KEY, '1');
      } else {
        window.sessionStorage.removeItem(ONE_INBOX_TOAST_KEY);
      }
    } catch (e) {
      // Storage can be blocked. The choice is saved either way.
    }
  }

  function takeRemembered() {
    try {
      var flag = window.sessionStorage.getItem(ONE_INBOX_TOAST_KEY) === '1';
      window.sessionStorage.removeItem(ONE_INBOX_TOAST_KEY);
      return flag;
    } catch (e) {
      return false;
    }
  }

  function showActionError() {
    var msg = window.tOr('common.pm.requests_action_error', 'Could not complete that action. Please try again.');
    if (typeof window.showError === 'function') window.showError(msg);
  }

  function offerUndo() {
    if (typeof window.showActionToast !== 'function') return;
    window.showActionToast(
      window.tOr('common.pm.requests_one_inbox_toast', "You're back to one inbox. Change it in the ⋯ menu."),
      {
        actionLabel: window.tOr('common.pm.requests_undo', 'Undo'),
        anchor: document.getElementById('threads_left_container'),
        onAction: function () {
          saveChoice(true).then(function () {
            window.location.reload();
          }).catch(showActionError);
        }
      }
    );
  }

  window.pmRequestsExplainer = function () {
    return {
      open: true,
      busy: false,

      gotIt: function () {
        if (this.busy) return;
        this.open = false;
        // A failed save leaves the choice unset, so the explainer returns on
        // the next visit. Nothing else depends on it.
        saveChoice(true).catch(function () {});
      },

      keepOne: function () {
        if (this.busy) return;
        var self = this;
        self.busy = true;
        saveChoice(false).then(function () {
          remember(true);
          window.location.reload();
        }).catch(function () {
          self.busy = false;
          showActionError();
        });
      }
    };
  };

  function init() {
    if (takeRemembered()) offerUndo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PmRequestsExplainer = {
    ONE_INBOX_TOAST_KEY: ONE_INBOX_TOAST_KEY,
    saveChoice: saveChoice,
    offerUndo: offerUndo
  };
})();
